import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category/movie',
    icon: 'ri-film-line',
    title: '电影专区',
    desc: '院线热映与经典佳片',
    tone: 'primary',
  },
  {
    to: '/category/tv',
    icon: 'ri-live-line',
    title: '电视剧专区',
    desc: '热播剧集同步追更',
    tone: 'accent',
  },
  {
    to: '/list/niche',
    icon: 'ri-award-line',
    title: '小众佳作',
    desc: '高分冷门口碑之选',
    tone: 'secondary',
  },
  {
    to: '/list/hot',
    icon: 'ri-fire-line',
    title: '热门推荐',
    desc: '当下最火的影视榜单',
    tone: 'primary',
  },
];

const toneMap: Record<string, string> = {
  primary: 'bg-primary-500/15 text-primary-300 group-hover:bg-primary-500',
  accent: 'bg-accent-500/15 text-accent-400 group-hover:bg-accent-500',
  secondary: 'bg-secondary-100 text-secondary-300 group-hover:bg-secondary-500',
};

export default function CategoryEntries() {
  return (
    <section className="px-4 md:px-6 lg:px-10 mt-12">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {entries.map((entry) => (
          <Link
            key={entry.to + entry.title}
            to={entry.to}
            className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-300/60 hover:border-primary-500/50 transition-colors"
          >
            <span
              className={`w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center text-2xl transition-colors ${toneMap[entry.tone]}`}
            >
              <i className={entry.icon} />
            </span>
            <span className="min-w-0">
              <span className="block text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {entry.title}
              </span>
              <span className="block mt-1 text-xs text-foreground-500 truncate">{entry.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}